export default __webpack_public_path__ + "static/media/logo_stride.5227e034.png";